import api from './index';
//

let exports = {};
// ========================== 设备特定服务商 ==========================
exports.getShopDevcSpecServicerList = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/devc/servicer/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.saveShopDevcSpecServicerList = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/devc/servicer/list/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateShopDevcSpecServicer = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/devc/servicer/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteShopDevcSpecServicer = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/devc/servicer/delete/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getShopDevcSpecServicerListByDevcId = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/devc/servicer/list/get/by/devcId')
    .data(data)
    .done(callback)
    .go();
};
exports.getShopDevcContractServicerListByDevcId = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/devc/contract/servicer/list/get/by/devcId')
    .data(data)
    .done(callback)
    .go();
};

exports.doDefaultShopDevcSpecServicer = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/devc/servicer/default/do')
    .data(data)
    .done(callback)
    .go();
};

// ========================== 常规服务特定服务商 ==========================
exports.getShopComnSpecServicerList = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/comn/servicer/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveShopComnSpecServicerList = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/comn/servicer/list/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.getShopComnSpecServicerListByDevcId = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/comn/servicer/list/get/by/devcId')
    .data(data)
    .done(callback)
    .go();
};

exports.getShopComnContractServicerListByDevcId = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/comn/contract/servicer/list/get/by/devcId')
    .data(data)
    .done(callback)
    .go();
};

exports.updateShopComnSpecServicer = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/comn/servicer/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteShopComnSpecServicer = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/comn/servicer/delete/do')
    .data(data)
    .done(callback)
    .go();
};
exports.doDefaultShopComnSpecServicer = function (data, callback) { // 设备特定服务商
    api.post('/spec/shop/comn/servicer/default/do')
    .data(data)
    .done(callback)
    .go();
};

// ================================================ 获取默认服务商服务 ===================================================
// 获取可用服务列表
exports.getServcList = function (data, callback) {
    api.post('/spec/servc/list/get')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/spec.js
// module id = 183
// module chunks = 0